var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageHeaderBlock)?_c(_vm.pageHeaderBlock.type,{key:_vm.pageHeaderBlock.index,tag:"component",attrs:{"block":_vm.pageHeaderBlock.block,"index":_vm.pageHeaderBlock.index}}):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(block){return _c(block.type,{key:block.index,tag:"component",attrs:{"block":block.block,"index":block.index}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }